import { render, staticRenderFns } from "./TabCapsulas.vue?vue&type=template&id=74ab22fc&scoped=true&"
import script from "./TabCapsulas.vue?vue&type=script&lang=js&"
export * from "./TabCapsulas.vue?vue&type=script&lang=js&"
import style0 from "./TabCapsulas.vue?vue&type=style&index=0&id=74ab22fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ab22fc",
  null
  
)

export default component.exports